import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabla',
  templateUrl: './tabla.component.html',
  styleUrls: ['./tabla.component.scss']
})
export class TablaComponent implements OnInit {
  arrayComponent: any;
  componentRender: any;
  codeList: any;
  infoComponent: any;
  utils: any;
  constructor() {
    this.utils = window.utils;
    this.codeList = {
      jqueryDatatable:
      `
        <!-- js jquery datatable -->
        <script src="https://cdn.datatables.net/1.10.20/js/jquery.dataTables.min.js"></script>
      `,
      jqueryCss:
      `
        <!-- css jquery datatable -->
        <link rel="stylesheet" href="https://cdn.datatables.net/1.10.20/css/jquery.dataTables.min.css" />
      `
    };
    this.arrayComponent = [
      {
        id: 'basica',
        titulo: 'Básica',
        subtitulo: '',
        claseContainer: 'col-12',
        componentRender:
          `<div class="govco-table govco-table-basic">
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">Medio</th>
        <th scope="col">Detalle</th>
      </tr>
    </thead>
    <tbody>
      <tr">
        <td>WEB</td>
        <td><a href="">Registros de datos en linea</a></td>
      </tr>
    </tbody>
  </table>
</div>
`,
      }, {
        id: 'simple',
        titulo: 'Simple',
        subtitulo: '',
        componentRender:
          `<div class="govco-table govco-table-simple">
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">Medio</th>
        <th scope="col">Detalle</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>WEB</td>
        <td><a href="/">Registros de datos en linea</a></td>
      </tr>
    </tbody>
  </table>
</div>`,
      },
      {
        id: 'checkbox',
        titulo: 'Tabla con checkbox',
        subtitulo: '',
        claseContainer: 'col-12',
        componentRender:
          `<div class="table-simple-headblue-govco">
    <table class="table display table-responsive-sm table-responsive-md" style="width:100%">
      <thead>
        <tr>
          <th>Nombre</th>
          <th>No. Crédito</th>
          <th>Estado</th>
          <th>Valor</th>
          <th>Selecciona</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Prestamo hipotecario</td>
          <td>123456789</td>
          <td class="state-success">Concepto definitivo</td>
          <td>$50.000.000.</td>
          <td>
            <div class="checkbox-govco">
              <input type="checkbox" id="check1" />
              <label class="label-checkbox m-auto" for="check1">
                  <div class="chk"></div>
              </label>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
</div> `,
      },{       
      id: 'paginacion',
      titulo: 'Paginación y filtros',
      subtitulo: '',
      claseContainer: 'col-12',
      componentRender:
`<div class="table-pagination-govco">
    <table 
    id="DataTables_Table_0" 
    class="table-govco table-responsive-sm table-responsive-md" 
    style="width:100%">
        <thead>
            <tr>
                <th>Name</th>
                <th>Position</th>
                <th>Office</th>
                <th>Age</th>
                <th>Start date</th>
                <th>Salary</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Tiger Nixon</td>
                <td>System Architect</td>
                <td>Edinburgh</td>
                <td>61</td>
                <td>2011/04/25</td>
                <td>$320,800</td>
            </tr>
            <tr>
                <td>Garrett Winters</td>
                <td>Accountant</td>
                <td>Tokyo</td>
                <td>63</td>
                <td>2011/07/25</td>
                <td>$170,750</td>
            </tr>
            <tr>
                <td>Ashton Cox</td>
                <td>Junior Technical Author</td>
                <td>San Francisco</td>
                <td>66</td>
                <td>2009/01/12</td>
                <td>$86,000</td>
            </tr>
            <tr>
                <td>Cedric Kelly</td>
                <td>Senior Javascript Developer</td>
                <td>Edinburgh</td>
                <td>22</td>
                <td>2012/03/29</td>
                <td>$433,060</td>
            </tr>
            <tr>
                <td>Airi Satou</td>
                <td>Accountant</td>
                <td>Tokyo</td>
                <td>33</td>
                <td>2008/11/28</td>
                <td>$162,700</td>
            </tr>
            <tr>
                <td>Brielle Williamson</td>
                <td>Integration Specialist</td>
                <td>New York</td>
                <td>61</td>
                <td>2012/12/02</td>
                <td>$372,000</td>
            </tr>
            <tr>
                <td>Herrod Chandler</td>
                <td>Sales Assistant</td>
                <td>San Francisco</td>
                <td>59</td>
                <td>2012/08/06</td>
                <td>$137,500</td>
            </tr>
            <tr>
                <td>Rhona Davidson</td>
                <td>Integration Specialist</td>
                <td>Tokyo</td>
                <td>55</td>
                <td>2010/10/14</td>
                <td>$327,900</td>
            </tr>
            <tr>
                <td>Colleen Hurst</td>
                <td>Javascript Developer</td>
                <td>San Francisco</td>
                <td>39</td>
                <td>2009/09/15</td>
                <td>$205,500</td>
            </tr>
            <tr>
                <td>Sonya Frost</td>
                <td>Software Engineer</td>
                <td>Edinburgh</td>
                <td>23</td>
                <td>2008/12/13</td>
                <td>$103,600</td>
            </tr>
            <tr>
                <td>Jena Gaines</td>
                <td>Office Manager</td>
                <td>London</td>
                <td>30</td>
                <td>2008/12/19</td>
                <td>$90,560</td>
            </tr>
        </tbody>
    </table>
</div>`,
codejs: 
`const configTable = {
  idSelector: 'DataTables_Table_0',
  pageLength: 5,
  pagingType: 'full number',
  responsive: 'true',
  info: false,
  lengthChange: true,
  language: {
    emptyTable: 'No se encontraron registros coincidentes',
    search: 'Resultados',
    searchPlaceholder: 'Busqueda'
  }
};
utils.setConfigTable(configTable);
`
      }
    ];

    this.infoComponent = {
      titulo: "Tablas",
      descripcion: ""
    }

  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    const configTable = {
      idSelector: 'DataTables_Table_0',
      pageLength: 5,
      pagingType: 'simple_numbers',
      responsive: 'true',
      info: false,
      lengthChange: true,
      language: {
        emptyTable: 'No se encontraron registros coincidentes',
        search: 'Resultados',
        searchPlaceholder: 'Busqueda'
      }
    };
    this.utils.setConfigTable(configTable);
  }
}


